import { Button2 } from "@/ui2/atoms/Button";
import { ModalControlled2, ModalDivider } from "@/ui2/molecules/Modal";

type OptOutConfirmationModalProps = {
  isModalOpen: boolean;
  onCancelPress: () => void;
  onConfirmPress: () => void;
  onOpenChange: (isOpen: boolean) => void;
  patientName: string;
};

export function OptOutConfirmationModal({
  isModalOpen,
  onCancelPress,
  onConfirmPress,
  onOpenChange,
  patientName,
}: OptOutConfirmationModalProps) {
  return (
    <ModalControlled2
      isOpen={isModalOpen}
      onOpenChange={onOpenChange}
      title="Opt out from Advanced Care Program?"
    >
      <p className="body-md tw:text-text-secondary">
        At the patient's request, this will remove {patientName}'s Advanced
        <br />
        Care Program consent.
      </p>

      <ModalDivider />

      <div className="tw:flex tw:justify-end tw:gap-x-3">
        <Button2 onPress={onCancelPress} size="md" variant="secondary">
          Cancel
        </Button2>

        <Button2 onPress={onConfirmPress} size="md" variant="destructive-secondary">
          Opt Out
        </Button2>
      </div>
    </ModalControlled2>
  );
}
